<template>

  <svg
    t="1640065018551"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3996"
    width="64"
    height="64"
  ><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.30000001-28.70000001-64-64-64H352c-35.30000001 0-64 28.70000001-64 64v80h72v-72zM864 256H160c-17.70000001 0-32 14.30000001-32 32v32c0 4.4 3.6 8 8 8h60.4l24.70000001 523c1.6 34.10000001 29.8 61 63.89999999 61h454c34.2 0 62.30000001-26.8 63.90000001-61l24.69999999-523H888c4.4 0 8-3.6 8-8v-32c0-17.70000001-14.30000001-32-32-32zM731.30000001 840H292.69999999l-24.19999998-512h486.99999998l-24.19999998 512z" p-id="3997" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconDelete',
} as DefineComponent
</script>